import React from "react";
import { usePublicPageSection } from "../../../../hooks/usePublicPageSection";
import { useLanguage } from "../../../../context/LanguageContext";
import "./Hero.css";

const requireField = (fields, key) => {
  const value = fields?.[key];
  if (value == null || String(value).trim() === "") {
    throw new Error(`Law hero field "${key}" is missing from the API response.`);
  }
  return value;
};

const buildModel = (section) => {
  const f = section.fields || {};
  return {
    badge: requireField(f, "badge"),
    title: requireField(f, "title"),
    subtitle: requireField(f, "subtitle"),
  };
};

const Hero = () => {
  const { meta } = useLanguage();
  const { model, error, isLoading } = usePublicPageSection("law", "hero", buildModel);

  if (isLoading) {
    return (
      <section className="law-hero" dir={meta.dir}>
        <div className="law-hero__content">
          <p style={{ color: "#64748b", fontSize: 14 }}>Loading…</p>
        </div>
      </section>
    );
  }

  if (error || !model) {
    return (
      <section className="law-hero" dir={meta.dir}>
        <div className="law-hero__content">
          <p style={{ color: "#b91c1c", fontSize: 14 }}>
            {error || "Law hero unavailable."}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="law-hero" dir={meta.dir}>
      <div className="law-hero__content">
        <span className="law-hero__badge">{model.badge}</span>
        <h1 className="law-hero__title">{model.title}</h1>
        <p className="law-hero__subtitle">{model.subtitle}</p>
      </div>
    </section>
  );
};

export default Hero;
